
import { FilterName } from '@/stores/filter.store';
import BasicButton from '@/ui-components/BasicButton.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const Filter = namespace('filter');

@Component({
	name: 'ResetButton',
	components: { BasicButton },
})
export default class ResetButton extends Vue {
	@Prop({ default: () => [] }) filterNames: FilterName[];
	@Prop({ default: true }) updateRouteState: boolean;
	@Prop({ default: false }) keepProvidersState: boolean;
	@Prop({ default: false }) keepContentTypeState: boolean;

	@Filter.Action resetFilters: (payload: { filterNames: FilterName[]; updateRouteState: boolean }) => void;
	@Filter.Action reset: (payload: { keepProvidersState: boolean; keepContentTypeState: boolean }) => void;

	clickHandler() {
		// Note: Reset providers selection for SEO users, since we still use old Filters bar for SEO users
		return this.filterNames.length > 0
			? this.resetFilters({ filterNames: this.filterNames, updateRouteState: this.updateRouteState })
			: this.reset({
					keepProvidersState: this.keepProvidersState,
					keepContentTypeState: this.keepContentTypeState,
			  });
	}
}
